module.exports = __webpack_public_path__ + "static/img/search.60f6f864.svg";